/**
 * SureSpool: the product page quantity box may go down to 0 (blocks/quantity.liquid passes min 0).
 * At 0 there is nothing to add, so the Add to cart button, the sticky bar button and Buy it now pause
 * until the buyer presses + again. Buttons that were already disabled (sold out) are left alone.
 */
const ZERO_CLASS = 'ss-qty-zero';

/** @param {Element} form */
function sync(form) {
  const input = form.querySelector('quantity-selector-component input[type="number"]');
  if (!(input instanceof HTMLInputElement)) return;
  const isZero = (parseInt(input.value, 10) || 0) <= 0;

  const buttons = [
    ...form.querySelectorAll('[ref="addToCartButton"]'),
    ...document.querySelectorAll('sticky-add-to-cart [ref="addToCartButton"]'),
  ];
  for (const button of buttons) {
    if (!(button instanceof HTMLButtonElement)) continue;
    if (isZero && !button.disabled) {
      button.disabled = true;
      button.dataset.ssQtyZero = 'true';
    } else if (!isZero && button.dataset.ssQtyZero === 'true') {
      button.disabled = false;
      delete button.dataset.ssQtyZero;
    }
  }

  form.classList.toggle(ZERO_CLASS, isZero);
}

function syncAll() {
  document.querySelectorAll('product-form-component').forEach(sync);
}

/** Wait a moment so the quantity component has written its new value (a timer also runs in background tabs). */
function schedule() {
  setTimeout(syncAll, 30);
}

document.addEventListener('quantity-selector:update', schedule);
document.addEventListener('change', (event) => {
  if (event.target instanceof Element && event.target.closest('quantity-selector-component')) schedule();
});
document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('quantity-selector-component')) schedule();
});

// Never send 0 spools: stop the form before the theme adds the default 1.
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
    if (form?.classList.contains(ZERO_CLASS)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

schedule();
